export default {
  method_unavailable: 'Este método de pagamento não está disponível de momento. Escolha outro.',
  payment_option_unavailable:
    'Esta opção de pagamento não está disponível neste momento. Escolha outra forma de pagar.',
  online_payment_unavailable: 'O pagamento online não está disponível de momento. Tente novamente dentro de instantes.',
  retry_payment_methods: 'Tentar novamente',
  payment_not_ready: 'O seu pagamento ainda está a ser preparado. Tente novamente dentro de instantes.',
  wallet_total_changed: 'O total deste método de pagamento mudou. Verifique-o e toque novamente no botão.',
  wallet_tap_above: 'Toque no botão {{method}} acima para pagar ou escolha outra forma de pagar.',
  wallet_pay_above: 'Use o botão {{method}} acima',
  element_incomplete: 'Preencha os dados de pagamento para continuar.',
  element_incomplete_card: 'Verifique os dados do cartão e tente novamente.',
  element_incomplete_bank: 'Escolha o seu banco para continuar.',
  element_incomplete_sepa_debit: 'Verifique o seu IBAN e os dados do titular da conta para continuar.',
};
